import classNames from 'classnames';
import React from 'react';
import { ButtonColor } from '../../enums/ButtonColor';

interface Props {
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  type?: 'submit' | 'button';
  classname?: string;
  color?: keyof typeof ButtonColor;
  children: React.ReactNode;
}

const OutlineButton: React.FC<Props> = (props) => {
  const { onClick, disabled, type, classname, color, loading, children } =
    props;

  let mainColor =
    'border-indigo-600 text-indigo-600 hover:bg-indigo-50 focus:ring-indigo-600';
  let disabledColor = 'border-indigo-300 text-indigo-300 hover:bg-transparent';

  switch (color) {
    case 'green': {
      mainColor =
        'border-green-600 text-green-600 hover:bg-green-50 focus:ring-green-600';
      disabledColor = 'border-green-300 text-green-300 hover:bg-transparent';
      break;
    }
    case 'red': {
      mainColor =
        'border-red-600 text-red-600 hover:bg-red-50 focus:ring-red-600';
      disabledColor = 'border-red-300 text-red-300 hover:bg-transparent';
      break;
    }
    case 'blue':
      break;
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={classNames(
        'focus:outline-none text-sm font-medium inline-flex items-center rounded-md border px-4 py-2 shadow-sm focus:ring-2 focus:ring-offset-2',
        {
          [mainColor]: !disabled,
          [disabledColor]: disabled,
        },
        classname
      )}
    >
      {loading ? 'Loading' : children}
    </button>
  );
};

export default OutlineButton;
